import React, { Component } from 'react';
import styles from './responsiveView.scss';
import CustomAnchorTag from '../../../Common/CommonComponents/CustomAnchorTag/customAnchorTag';
import SearchBox from '../../../Common/SearchBox/searchBox';
import Toggle from '../../BillingAndPayment/Common/Toggle';
import RatePopupPlan from '../../Common/ratePopupPlan';
import DownloadBillLoader from '../../../Common/CommonComponents/DownloadBillSpinner/downloadBillLoader';
import AccordianLayout from './AccordianLayout/accordianLayout';
import AccountDetailsPopup from '../../Common/accountDetailsPopup';
import NoDataBlock from '../../../Common/NoDataBlock/noDataBlock';
import ReactHtmlParser from 'react-html-parser';
export default class ResponsiveViewManageAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
      isRatePlanOpenPopup: false,selectedServAcc:null,selectedCustomer:null,isServicePlanPopup:false
    };
    
    this.initialPositionValue = window.getComputedStyle(document.body).position;
    this.isTablet = app.appUtil.FormatUtil.isTablet();
    this.initialOverflowValue = window.getComputedStyle(document.body).overflowY;
    this.downarrowblack = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_chevron_green.svg';
    this.loadingWheel = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_loading.gif';
    this.isSearchData = this.props.isSearchModeOn && this.props.searchedData && this.props.searchedData.length;
    this.showRatePlanDisclaimerRates = '#T8DRTP#T8DRTPS#TG1DRTP#TG2DRTP#TG3DRTP#TP2DRTP#TP3DRTP#';
  }
  
  getInnerContent = (customerNo,index,details,totalSACount) => {

    return (
      <AccordianLayout clickOnXBtn={this.state.clickOnXBtn} handleClickOnXBtn={this.props.handleClickOnXBtn} saFilteredList={this.props.saFilteredList} searchDataServiceList={this.props.searchDataServiceList} totalSACount={totalSACount} setInnerTableLoader={this.props.setInnerTableLoader} searchBarInfo={this.props.searchBarInfo} searchedData={this.props.searchedData} customerNo={customerNo} custDetails={details} setSelectedSA={this.setSelectedSA.bind(this)} index={index} getFormattedServAddress={this.getFormattedServAddress.bind(this)} />
    );
  }
  setSelectedSA=(item,custDetail,name)=>{
    if(name==="service"){
      this.setState({selectedServAcc:item,isServicePlanPopup:true,selectedCustomer:custDetail});
    }else{
      this.setState({selectedServAcc:item,isRatePlanOpenPopup:true,selectedCustomer:custDetail});

    }
  }
  capitaliser = (mySentence) => {
    let words = mySentence.trim().split(" ");
    words.length < 1 ? words.push(mySentence) : null;
    let reframedSentence = words.map((word) => {
      let reframed = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      return reframed;
    }).join(" ");
    return reframedSentence;
  };
  
  getHeaderTitle = () => {
    let noOfData = this.props.searchedData.length ? <div className={styles.sceNoOfAccountsBlock}>1 Matching Account Found</div>
      : <div className={[styles.sceNoOfAccountsBlock, this.props.searchBarInfo.isError ? styles.sceExtraMargin : null].join(" ")}>{`${this.props.pageStartCount}–${this.props.pageEndCount} of ${this.props.totalCAAccount} Customer Accounts`}</div>;
    let sortDrpDwn = this.props.handleSortDropDown();
    return (
      <div className={styles.sceNoOfAccountsSort}>
        {noOfData}
        {
          this.props.searchedData.length?null:(
           <div>{sortDrpDwn}</div>
          )}
        
      </div>
    );
  }
  getFormattedServAddr=(servAddress={})=>{
    let unitNumAvailable = servAddress?servAddress.unitNumber !== '' ? servAddress.unitNumber : '':"";
    let formattedAddr = Object.entries(servAddress).map(([key, value]) => {
      let values = value;
      if (values !== '' && key !== 'unitNumber') {
        if (key !== "serviceaccountAddressNum" && key !== "serviceaccountStateCode" && key !== "serviceaccountZipcode") {
          values = this.capitaliser(values);
        }
        let addComma = ((key === 'serviceaccountStreetAddress' && !unitNumAvailable) || (key === 'serviceaccountMailingCity')) ? ',' : '';
        if(key==='serviceaccountZipcode'){
          values = values.split('-')[0];
        }else{
          values = ((key === 'serviceaccountStreetAddress') && unitNumAvailable) ? values + ', ' + unitNumAvailable + ', ' : values;

        }
        return values + addComma;
      }
    }).join(' ');
    return formattedAddr;
  }
  getFormattedServAddress(servAddress={}) {
    let unitNumAvailable = servAddress?servAddress.unitNumber !== '' ? servAddress.unitNumber : '':"";
    let formattedAddr = Object.entries(servAddress).map(([key, value]) => {
      let values = value;
      if (values !== '' && key !== 'unitNumber') {
        if (key==="postBoxNumber"){
          values = "PO box "+values;
        }
        if (key !== "houseNumber" && key !== "stateCode" && key !== "zipCode" && key !== "postBoxNumber"&& key !== "addrNum") {
          values = this.capitaliser(values);
        }
        let addComma = ((key === 'streetAddr') || (key === 'mailingCityName')|| (key === 'postBoxNumber')|| (key === 'addrNum')) ? ',' : '';
        if(key==='zipCode'){
          values = values.split('-')[0];
        }else{
          values = ((key === 'streetAddr') && unitNumAvailable) ? values + ', ' + unitNumAvailable + ', ' : values;

        }
        return values + addComma;
      }
    }).join(' ');
    return formattedAddr;
  }
  formatMailingAddressPopup(servAddress) {    
    let firstLine = [],secondLine = [];
    // Check if poBox is provided
    if (servAddress.postBoxNumber) {
        firstLine.push(`PO box ${servAddress.postBoxNumber}`);} 
        // Combine house number and street if poBox is not present
        if (servAddress.houseNumber && servAddress.streetAddr) {
            firstLine.push(`${servAddress.houseNumber} ${this.capitaliser(servAddress.streetAddr)}`);}
        else if(servAddress.houseNumber){
            firstLine.push(servAddress.houseNumber);
        }else if(servAddress.streetAddr){
            firstLine.push(`${this.capitaliser(servAddress.streetAddr)}`);
        }
        // Add supplement if it exists
        if (servAddress.addrNum) {
            firstLine.push(`${servAddress.addrNum }, `);}
            else{firstLine.push("");}

    // Build second line with city, region, and postal code
    if (servAddress.mailingCityName) {
        secondLine.push(this.capitaliser(servAddress.mailingCityName));}
    if (servAddress.stateCode) {
        secondLine.push(`${servAddress.stateCode} ${servAddress.zipCode.split('-')[0]}`);}
    
    return (<div><div>{firstLine.join(', ')}</div><div>{secondLine.join(', ')}</div></div>);}
  getCustName=(name="")=>{
    let names = name?name.trim().split(','):[];
    names.reverse();
    names = names.map((item=>this.capitaliser(item)));
    let ans = names.join(' ');
    return ans;}

  openClosePopup = (actionType, index) => {
    
    let events = {
      alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'multi_grid'
  };
  app.analyticsService.addPageLevelData('eventCapturing', events);
    if(actionType === 'open' && index!==undefined){ 
    this.setState({ isServicePlanPopup:true});}
    else{
        window.aUtils ? window.aUtils.sendAAEvent("link", `settings|accounts|none|none|page|close`) : null;      
        this.setState({ isServicePlanPopup: false, selectedServAcc:null, selectedCustomer :null});}}

  overlayFocusController() {
    if (this.state.isRatePlanOpenPopup || this.state.isServicePlanPopup) {
        if(this.isTablet){
            document.body.style.overflowY = 'hidden';
        }else{
            document.body.style.overflowY = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
        }
    } else {
        if(this.isTablet){
            document.body.style.overflowY = this.initialOverflowValue;
        }else{
            document.body.style.overflowY = this.initialOverflowValue;
            document.body.style.position = this.initialPositionValue;
            document.body.style.removeProperty("width");}}}

  ratePlanOpenClosePopup = (actionType, index) => {
    let events = {
      alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'multi_grid'
  };
  app.analyticsService.addPageLevelData('eventCapturing', events);
    if(actionType === 'open' && index!==undefined){ 
    this.setState({ isRatePlanOpenPopup: true});}
    else{
        window.aUtils ? window.aUtils.sendAAEvent("link", `settings|accounts|multi_grid|none|page|close`) : null;
        this.setState({ isRatePlanOpenPopup: false, selectedServAcc:null, selectedCustomer :null});}
  }
  getSmartAccountVerify(isSmart){
    return isSmart && isSmart === 'Y';
  }
  getServProviderTypeDetail(providerType){
    let isCCAorDAorTBS = providerType.includes('CCA') || providerType.includes('DA')||providerType.includes('TBS')|| this.showRatePlanDisclaimerRates.indexOf('#'+this.state.selectedServAcc.servicePlanHistoryData[0].servicePlanCode+'#') !== -1;
    return isCCAorDAorTBS;
}
  getPopup=(name)=>{
    let addrd = this.getFormattedServAddr(this.state.selectedServAcc.serviceAccountAddress).trim();
    let address= addrd.split(' ').join(" ");

    let caNum = this.state.selectedCustomer?this.state.selectedCustomer.contractAccountNumber:null;
    let popup = name ==="service"?<AccountDetailsPopup firstName={"firstName"} lastName={"Lastname"} customerAccountName={this.state.selectedCustomer?this.getCustName(this.state.selectedCustomer.businessPartnerName):null} serviceStreetAddress={this.state.selectedServAcc?address:null} rotatingOutageGrpId={this.state.selectedServAcc?this.state.selectedServAcc.rotateGrpId:null} contractNumber={this.state.selectedServAcc?this.state.selectedServAcc.contractNumber:null}
     serviceAccountStatusCode={this.state.selectedServAcc?this.state.selectedServAcc.serviceAccountStatusCode:null} contractStartDate={this.state.selectedServAcc?this.state.selectedServAcc.contractStartDate:null} contractEndDate={this.state.selectedServAcc?this.state.selectedServAcc.contractEndDate:null} currentServicePlan={this.state.selectedServAcc?this.state.selectedServAcc.currentServicePlan:null} podId={this.state.selectedServAcc?this.state.selectedServAcc.podId:null} contractAccountNumber={caNum}
    mailingAddress={this.state.selectedCustomer?this.formatMailingAddressPopup(this.state.selectedCustomer.custAddress):null} openClosePopup={this.openClosePopup} />
    :<RatePopupPlan isSmartAccount={this.state.selectedServAcc?this.getSmartAccountVerify(this.state.selectedServAcc.serviceAccountDetailData.serviceAccountSmartConnectFlag):false} serviceStreetAddress={this.state.selectedServAcc?address:null}  content={this.props.drupalContent.your_ratePlan} serviceProviderType={this.state.selectedServAcc?this.getServProviderTypeDetail(this.state.selectedServAcc.serviceProviderType):null} buisnessPartnerNumber={this.state.selectedCustomer?this.state.selectedCustomer.buisnessPartnerNumber :null} rateCategory={this.state.selectedServAcc?this.state.selectedServAcc.currentServicePlan:null}  contractNumber={this.state.selectedServAcc?this.state.selectedServAcc.contractNumber:null} contractAccountNumber={caNum} ratePlanOpenClosePopup={this.ratePlanOpenClosePopup} accountData={this.state.selectedServAcc} vintageYear={this.props.vintageYear} />;

    return (
        <div>
            {popup}
        </div>
        
    );
  }
  toggleErrorRgx = () =>{
    let toggleErrorRgx = new RegExp('<span id="toggleError">([^]*?)</span>', 'g');
    if(!_.isEmpty(this.props.drupalContent)){ 
      let toggleErrorMsg = this.props.drupalContent.toggle_error.body.match(toggleErrorRgx);
      return {
        toggleError: {toggleErrorMsg: toggleErrorMsg ? ReactHtmlParser(toggleErrorMsg) : "",}
      }; 
  }else{
      return {
        toggleError: {toggleErrorMsg: "",}
      }; 
  }
  }
displayEdit=(contractAccountNumber)=>{
        app.appService.setSessionstorage('displayAddress', true);
        app.appService.setSessionstorage('canumber', contractAccountNumber);
        app.appUtil.navigateTo(app.appUtil.getAppRoutes().PROFILE_SETTINGS.UPDATE_MAILING_ADDRESS);}
  getRows = () => {
    let isSearchData = this.props.isSearchModeOn && this.props.searchedData && this.props.searchedData.length;
    let caList = this.props.accountDetails ? this.props.accountDetails.caList ? this.props.accountDetails.caList : [] : [];
    const data = isSearchData ? this.props.searchedData : caList;
    const caAddr = this.props.searchCaAddress ? this.props.searchCaAddress ? this.props.searchCaAddress : null : null;
    const isSearchedBySA = isSearchData && this.props.searchDataServiceList.length===1;
    let {toggleError} = this.toggleErrorRgx();
    return (
      <div className={styles.sceManageAccountCardRows}>
        {
           data.map((details, index) => {
            return (
              <div className={styles.sceManageAccountCardRow} id={`scroll${index}`}>
                <div className={styles.sceManageTopCard}>
                  <div className={styles.sceMngAcntActDetail}>
                    <div className={styles.sceMngAcntActDetailActNo}>Account: <span data-pii-encrypt>{details.contractAccountNumber}</span></div>
                    <div className={styles.sceMngAcntActNameMail}>
                      <div className={styles.sceMngAcntActName}>Customer Name: <span data-pii-encrypt className={styles.sceMngAcntActNameValue}>{this.getCustName(details.businessPartnerName)}</span></div>
                      <div className={styles.sceMngAcntActNameAddr}>Mailing Address: <span data-pii-encrypt className={styles.sceMngAcntActNameValue}>{isSearchData ? this.getFormattedServAddress(caAddr) : this.getFormattedServAddress(details.custAddress)}<a href="javascript:" onClick={()=>this.displayEdit(details.contractAccountNumber)}  className={styles.anchorTag}>Edit <i aria-hidden className='fas fa-pencil-alt' /></a></span></div>
                    </div>
                    <div className={styles.sceMngAcntActDetailLinkAccordian} onClick={() => this.props.fetchServiceAccountDetails(details.contractAccountNumber, index, `${isSearchedBySA?'1':details.totalsactCount} Service ${isSearchedBySA?'Account':details.totalsactCount>1?"Accounts":"Account"}`)}>
                      <CustomAnchorTag className={styles.sceCustomAnchorFontStyle} linkName={`${isSearchedBySA?'1':details.totalsactCount} Service ${isSearchedBySA?'Account':details.totalsactCount>1?"Accounts":"Account"}`} isBold /> <span><img alt='arrow' src={this.downarrowblack} className={this.props.serviceAccountIndex.includes(index)?styles.sceMngAcntActDetailLinkAccordianDrpDwn:styles.sceDownArrowAccordian} /></span>
                    </div>
                  </div>
                  <div className={styles.sceManageAccountToggleCard}>
                    <div className={styles.sceMangActToggleBlock}>
                      <div className={styles.sceManageAccountToggleContent}>Display Customer Account on Dashboard</div>
                      <Toggle isDisabled={this.props.savingChangesArr.includes(details.contractAccountNumber) || (this.props.totalManagedAccount<2 && details.enrollmentStatus === 'A')} id={index}  onColor="#00664F" isToggleOn={details.enrollmentStatus === 'A' ? true : false} handleChange={this.props.handleToggleChange.bind(this,details.contractAccountNumber, details.buisnessPartnerNumber, details.relationship, index)} rmMb />
                    </div>
                    {
                       this.props.savingChangesArr.includes(details.contractAccountNumber)  ? (
                        <div className={styles.sceSavingChanges}>
                          <img src={this.loadingWheel} className={styles.loaderWheelImg} />
                          <div className={styles.sceSavingChangesTitle}>Saving changes...</div>
                        </div>
                      ) : null
                    }
                          {
                            this.props.toggleErrorArr.includes(details.contractAccountNumber)?(
                              <div className={styles.sceToggleError}>
                                <div className={styles.scealertIconDivImgBlock}>
                                  <img className={styles.scealertIconDivImg} src={drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_warning.svg'} alt='alert' />
                                </div>
                                <div className={styles.sceAlertContent}>{toggleError.toggleErrorMsg}</div>
                              </div>
                            ):null
                          }                          
                  </div>
                  <div onClick={() => this.props.fetchServiceAccountDetails(details.contractAccountNumber, index, `${isSearchedBySA?'1':details.totalsactCount} Service ${isSearchedBySA?'Account':details.totalsactCount>1?"Accounts":"Account"}`)} className={styles.sceMngAcntActDetailLinkAccordianMobile}>
                  <CustomAnchorTag linkName={`${isSearchedBySA?'1':details.totalsactCount} Service ${isSearchedBySA?'Account':details.totalsactCount>1?"Accounts":"Account"}`} isBold /> <span><img alt='arrow' src={this.downarrowblack} className={this.props.serviceAccountIndex.includes(index)?styles.sceMngAcntActDetailLinkAccordianDrpDwn:styles.sceDownArrowAccordian} /></span>
                    
                    {/* <CustomAnchorTag linkName={`${details.totalsactCount} Service Accounts`} isBold /> <span><img alt='arrow' src={this.downarrowblack} className={this.props.serviceAccountIndex.includes(index) ?styles.sceMngAcntActDetailLinkAccordianDrpDwn: styles.sceDownArrowAccordian} /></span> */}
                  </div>
                </div>
                {this.props.serviceAccountIndex.includes(index) ? this.getInnerContent(details.contractAccountNumber,index,details,details.totalsactCount) : null}
              </div>
            );})}
      </div>);}

  getSearchCASALabelText=(searchLabelContent)=>{
        let searchCaSaLabelRgx = new RegExp('<span id="casa-label">([^]*?)</span>', 'g'), searchCaSaPlaceHolderRgx = new RegExp('<span id="casa-placeholder">([^]*?)</span>', 'g'),
        searchCaSaLabel = searchCaSaLabelRgx.exec(searchLabelContent.body), searchCaSaPlaceHolder = searchCaSaPlaceHolderRgx.exec(searchLabelContent.body);
        let searchBoxContent = {caSalabelContent: searchCaSaLabel?ReactHtmlParser(searchCaSaLabel[1]):"", caSaplaceholder: searchCaSaPlaceHolder?ReactHtmlParser(searchCaSaPlaceHolder[1]):""};
        return searchBoxContent;}
        
  render() {
    this.overlayFocusController();
    let paginationComponent = ((this.props.noDataOnSearch && this.props.isSearchModeOn) || this.props.searchedData.length) ? null : this.props.getPagination();
    let contentRows = this.props.noDataOnSearch && this.props.isSearchModeOn ? <NoDataBlock accountSearchType={""} content={this.props.drupalContent} isSearchTextError={this.props.searchBarInfo.isError} isCA isSA /> : (
      this.getRows()
    );
    let servicePopup = this.state.isServicePlanPopup && this.state.selectedServAcc!==null ?this.getPopup("service"):null;
    let ratePopup = this.state.isRatePlanOpenPopup && this.state.selectedServAcc!==null ?this.getPopup("rate"):null;
    let loader = this.props.mainTableLoader || this.props.innerTableLoader ? <DownloadBillLoader />:null;
    let headerTitle = this.props.noDataOnSearch && this.props.isSearchModeOn ? null : this.getHeaderTitle();
    
    let isSearchData = this.props.isSearchModeOn && this.props.searchedData && this.props.searchedData.length;
    let caList = this.props.accountDetails ? this.props.accountDetails.caList ? this.props.accountDetails.caList : [] : [];
    const data = isSearchData ? this.props.searchedData : caList;
    let searchLabelText = this.getSearchCASALabelText(this.props.drupalContent.dss_search_label);
    return (
      <div className={['container',styles.sceContainerMarginAuto].join(' ')}>
      {
          data.length?(
            <div className={styles.manageAccountPage}>
        
              <div className={styles.sceMngAcntSrchDiv}>
                <SearchBox searchBarInfo={this.props.searchBarInfo} handleCloseErrorBox={this.props.handleCloseErrorBox} handleSearchEvents={this.props.handleSearchEvents} searchLabel={searchLabelText.caSalabelContent} placeholder={searchLabelText.caSaplaceholder} isCA isSA content={this.props.drupalContent} />
                {headerTitle}
              </div>
              {servicePopup}
              {ratePopup}
              
              {contentRows}
              {paginationComponent}

            </div>):null}
        {loader}</div>);}}
